import axios, { AxiosResponse } from 'axios';

import { EPodTypDokumentu, EStavPodpisu } from 'enums/dokumentyEnums';

export const dokumentLoginSMS = (hash: string) => {
    return axios({
        method: 'POST',
        url: '/DOKodkaz/sms',
        data: {
            hash: hash
        }
    });
};

export const dokumentPodpisLoginSMSlogin = (hash: string, sms: string) => {
    return axios({
        method: 'POST',
        url: '/DOKodkaz/prihlasit',
        data: {
            hash: hash,
            sms: sms
        }
    }).then((resp: AxiosResponse<IPodpisIDs>) => resp.data);
};

export interface IPodpisIDs {
    platnost: boolean;
    iddok: number;
    idosoby: number;
    stav: EStavPodpisu;
    prihlasen?: boolean;
    token: string;
    podtyp: EPodTypDokumentu;
}

export const dokumentPodpisLoginGet = (hash: string) => {
    return axios({
        method: 'GET',
        url: '/DOKodkaz/',
        params: {
            hash: hash
        }
    }).then((resp: AxiosResponse<IPodpisIDs>) => resp.data);
};

export interface IPodpisData {
    identifikator: string;
    nazev: string;
    telefon: string;
    email: string;
    jmeno: string;
    prijmeni: string;
    stavpodpisu: EStavPodpisu; // stav podpisu dokument
    typpodpisu: string;
}

export const dokumentPodpisData = (idZadost: string | number, idOsoba: string | number, isJinaOsoba?: boolean) => {
    return axios({
        method: 'GET',
        url: `/${isJinaOsoba ? 'DOKjiny' : 'DOKodkaz'}/${idZadost}/osoba/${idOsoba}`
    }).then((resp: AxiosResponse<IPodpisData>) => resp.data);
};

export const dokumentSmsPDFdownload = (iddok: string | number, idosoba: string | number, name: string) => {
    return axios({
        method: 'GET',
        url: `/DOKodkaz/${iddok}/osoba/${idosoba}/pdfdownload`,
        responseType: 'blob' // important
    }).then((resp: { status: number; data: any }) => {
        if (resp.status === 200) {
            // způsob, jak stažený dokument otevřít v browseru
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const nav = window.navigator as any;
            // IE
            if (nav?.msSaveOrOpenBlob) {
                nav.msSaveOrOpenBlob(resp.data, name);
            } else {
                const odp = resp.data;

                const uriContent = URL.createObjectURL(
                    new Blob([odp], {
                        type: 'application/octetstream'
                    })
                );
                const link = document.createElement('a');
                link.style.display = 'none';
                link.download = name;
                link.href = uriContent;
                link.target = '_blank';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    });
};
export const banksignPodpisSmsRedirect = (iddok: string | number, idosoba: string | number, isJinaOsoba?: boolean) => {
    return axios({
        method: 'PUT',
        url: `/${isJinaOsoba ? 'DOKjiny' : 'DOKodkaz'}/${iddok}/osoba/${idosoba}/banksign`
    }).then((resp: AxiosResponse<{ redirect: string }>) => resp.data);
};

export const dokumentOsobySmsPodpisPUT = (
    idZadost: string | number,
    idOsoba: string | number,
    tempnazev: string,
    isJinaOsoba?: boolean
) => {
    return axios({
        method: 'PUT',
        url: `/${isJinaOsoba ? 'DOKjiny' : 'DOKodkaz'}/${idZadost}/osoba/${idOsoba}/elpodpis`,
        data: {
            tempnazev: tempnazev
        }
    }).then((resp: AxiosResponse<{ stav: string }>) => resp.data);
};

export const prepareFilePodpisSMS = (
    idzad: number | string,
    idOsoby: number | string,
    tempnazev: string,
    fileName: string
) => {
    return axios({
        method: 'PUT',
        url: `/DOKodkaz/${idzad}/osoba/${idOsoby}/prepare`,
        data: {
            tempnazev: tempnazev
        }
    }).then((resp: AxiosResponse<{ redirect: string }>) =>
        axios({
            method: 'GET',
            url: '/DOKodkaz/Download',
            params: {
                file: resp.data.redirect
            },
            responseType: 'blob' // important
        }).then((rezp: { status: number; data: any }) => {
            if (rezp.status === 200) {
                // způsob, jak stažený dokument otevřít v browseru
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const nav = window.navigator as any;
                // IE
                if (nav?.msSaveOrOpenBlob) {
                    nav.msSaveOrOpenBlob(rezp.data, fileName);
                } else {
                    const odp = rezp.data;

                    const uriContent = URL.createObjectURL(
                        new Blob([odp], {
                            type: 'application/octetstream'
                        })
                    );
                    const link = document.createElement('a');
                    link.style.display = 'none';
                    link.download = fileName;
                    link.href = uriContent;
                    link.target = '_blank';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }
        })
    );
};
